import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Tabs, { TabsProps } from './Tabs';
import {
    AccessibilityStore,
    DataStore,
    ScreenSizeStore,
    SuperscriptScope,
} from '../stores';
import { getFundTypeId } from '../utils/getFundTypeId';
import { FundType } from '../models/configuration/FundType';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { ConditionalDisclaimers } from '../models/configuration/disclaimers/ConditionalDisclaimers';
import TabRegion from '../models/components/TabRegion';
import { Theme } from '../models/Theme';
import { computed } from 'mobx';

interface FundTypeTabsProps {
    theme?: Theme;
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
    ConditionalDisclaimers?: ConditionalDisclaimers;
    screenSizeStore?: ScreenSizeStore;
}

@inject('dataStore', 'accessibilityStore', 'screenSizeStore')
@observer
class FundTypeTabs extends Component<FundTypeTabsProps> {
    @computed
    get fundTypeTabsStickyConfig() {
        const { stickyConfig } = this.props.screenSizeStore;
        return stickyConfig?.fundTypeTabs;
    }

    @computed
    get stickyOffset() {
        const offset = this.fundTypeTabsStickyConfig?.offset;
        if (offset || offset === 0) {
            return `${offset}px`;
        }
    }

    @computed
    get stickyPosition() {
        return this.fundTypeTabsStickyConfig?.enabled ? 'sticky' : 'static';
    }

    @computed
    get tabsProps(): TabsProps {
        const { dataStore, theme } = this.props;
        const selectedFundTypeId = getFundTypeId(
            dataStore.config.selectedFundType as FundType
        );
        return {
            region: TabRegion.FundType,
            tabs: dataStore.config.fundTypes.map(fundType => {
                return {
                    id: getFundTypeId(fundType as FundType),
                    label: fundType.label,
                    disclaimers: (fundType as FundType).disclaimers,
                };
            }),
            setTabActive: tab => {
                dataStore.logDataLayer('tab_navigation', {
                    tabRegion: TabRegion.FundType,
                    tabLabel: tab.label,
                });
                dataStore.config.setFundType(tab);
            },
            isTabSelected: tabId => tabId === selectedFundTypeId,
            getMetricContext: tab => `fundTypeTabs-${camelCase(tab.label)}`,
            tabThemeOverride: theme.FundTypeTab,
        };
    }

    render() {
        const { theme, accessibilityStore } = this.props;
        return (
            <Tabs
                {...this.tabsProps}
                {...theme.FundTypeTabs}
                aria-label={accessibilityStore.fundTypesLandmark}
                superscriptScope={SuperscriptScope.module}
                position={this.stickyPosition}
                top={this.stickyOffset}
            />
        );
    }
}

export default withTheme(FundTypeTabs);



// WEBPACK FOOTER //
// ./src/Components/FundTypeTabs.tsx